// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-next',
  revision: '53e185b1e',
  branch: 'next',
  date: 'Fri, 13 Feb 2026 10:32:01 GMT'
};